var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',[(_vm.checkAccessPrivilege('Payment.Level.BankMaintenance.ManualDeposit'))?_c('b-tab',{attrs:{"title":"Manual Deposit"}},[_c('manual-deposit')],1):_vm._e(),_vm._v(" "),(_vm.checkAccessPrivilege('Payment.Level.BankMaintenance.AutoCashIn'))?_c('b-tab',{attrs:{"title":"Auto Cash In"}},[_c('auto-cash-in')],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6011b984","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/payment/viplevel/VIPLevelBankAccountTable.vue
// module id = 1182
// module chunks = 1